<template>
  <div>
    <Toolbar :handle-submit="onSendForm" :handle-reset="resetForm">
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-clipboard-list</v-icon>{{$t('profile.setupdefinition.definitions')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <SetupDefinitionForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import SetupDefinitionForm from '../../components/setupdefinition/Form';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import CreateMixin from '../../mixins/CreateMixin';

const servicePrefix = 'SetupDefinition';

const { mapFields } = createHelpers({
  getterType: 'setupdefinition/getField',
  mutationType: 'setupdefinition/updateField'
});

export default {
  name: 'SetupDefinitionCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    SetupDefinitionForm
  },
  data() {
    return {
      item: {}
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('setupdefinition', ['create', 'reset'])
  }
};
</script>
